import type { Accessor, Context } from 'solid-js'
import { createContext, useContext } from 'solid-js'

export interface AccordionContextType {
  multiple: Accessor<boolean>
  isOpen: (value: string) => boolean
  toggle: (value: string) => void
}

export const AccordionContext: Context<AccordionContextType | undefined> = createContext<AccordionContextType | undefined>(undefined)
export const useAccordionContext = () => useContext(AccordionContext)
